module.exports = __webpack_public_path__ + "static/img/pro-card.5faa2b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/RF_assets/cards/pro-card.png
// module id = Zu8Z
// module chunks = 27